<div fxFlex fxLayout="column" class="add-channels">
  @if (step === 1) {
    <div fxFlex fxLayout="column" fxLayoutAlign="start center">
      <button fxFlex="none" fxFlexAlign="end" mat-button (click)="back()">
        <mat-icon>close</mat-icon>
      </button>
      <div fxFlex fxLayout="column" fxLayoutAlign="start center">
        <div fxFlex="none">{{ selectMessengerText }}</div>
        <div
          fxFlex
          class="channel-list"
          fxLayout="row wrap"
          fxLayoutAlign="start start"
        >
          @for (provider of providers; track provider) {
            <div
              class="provider-button"
              fxLayout="column"
              fxLayoutAlign="center center"
              (click)="selectProvider(provider)"
            >
              <app-provider-icon
                fxFlex="none"
                [provider]="provider"
              ></app-provider-icon>
              <div fxFlex="none">
                {{ getProviderName(provider) }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (step === 2) {
    <div fxFlex fxLayout="column">
      <div fxFlex="none" fxLayout="row" fxLayoutAlign="space-between stretch">
        <a fxFlex="none" mat-button (click)="init()"
          ><mat-icon>chevron_left</mat-icon> {{ selectAnotherMessengerText }}</a
        >
        <a fxFlex="none" mat-button (click)="back()"
          ><mat-icon>close</mat-icon></a
        >
      </div>
      @if (selectedProvider === 'telegram') {
        <app-channels-telegram
          (newChannel)="providerCreated($event)"
        ></app-channels-telegram>
      }
      @if (
        selectedProvider === 'facebook' || selectedProvider === 'instagram'
      ) {
        <app-channels-facebook
          [provider]="selectedProvider"
          (newChannel)="providerCreated($event)"
        ></app-channels-facebook>
      }
      @if (selectedProvider === 'zendesk') {
        <app-channels-zendesk
          (newChannel)="providerCreated($event)"
        ></app-channels-zendesk>
      }
      @if (selectedProvider === 'webchat') {
        <app-channels-webchat
          (newChannel)="providerCreated($event)"
        ></app-channels-webchat>
      }
      @if (selectedProvider === 'whatsapp') {
        <app-channels-whatsapp
          [provider]="selectedProvider"
          (newChannel)="providerCreated($event)"
        ></app-channels-whatsapp>
      }
      @if (selectedProvider === 'whatsapp_playground') {
        <app-channels-whatsapp-playground
          (newChannel)="providerCreated($event)"
        ></app-channels-whatsapp-playground>
      }
      @if (selectedProvider === 'generic') {
        <div class="generic">
          <h3>
            {{ genericChannelTitle }}
          </h3>
          <p>{{ genericChannelContact }}</p>
        </div>
      }
    </div>
  }

  @if (step === 3) {
    <div fxFlex fxLayout="column" fxLayoutAlign="center center">
      <mat-spinner [diameter]="32" [strokeWidth]="3.2"></mat-spinner>
      <h2 fxFlex="none">{{ connectingText }}</h2>
    </div>
  }

  @if (step === 4) {
    <div fxFlex fxLayout="column">
      <button fxFlex="none" fxFlexAlign="end" mat-button (click)="back()">
        <mat-icon>close</mat-icon>
      </button>
      <h2>{{ successTitle }}</h2>
      <p>{{ integrationReadyText }}</p>
      <p>
        {{ connectedPrefixText }}
        @if (queue) {
          <span>{{ connectedQueueText }}</span>
        }
        @if (bot) {
          <span>{{ connectedBotText }}</span>
        }
        .
      </p>
      @if (selectedProvider === 'webchat') {
        <div>
          <p [innerHTML]="webchatInstructionsText"></p>
          <p>
            {{ moreInfoDocsText }}
            <a href="https://docs.botonic.io"> {{ botonicDocsText }} </a>
          </p>
          <app-webchat-snippet
            [showCodeSnippet]="true"
            [providerAccount]="providerAccount"
            [botConfig]="botConfig"
          ></app-webchat-snippet>
        </div>
      }
      @if (selectedProvider === 'whatsapp_playground') {
        <div>
          <p>{{ testBotNumberText }}</p>
          <h3>{{ providerAccount?.username }}</h3>
        </div>
      }
      <button
        mat-raised-button
        flex="none"
        type="button"
        class="main-btn"
        (click)="init()"
      >
        {{ addAnotherMessengerText }}
      </button>
      <button mat-button flex="none" type="button" (click)="back()">
        {{ finishText }}
      </button>
    </div>
  }

  @if (step === 5) {
    <div fxFlex fxLayout="column">
      <button fxFlex="none" fxFlexAlign="end" mat-button (click)="back()">
        <mat-icon>close</mat-icon>
      </button>
      <h2>{{ errorTitleText }}</h2>
      <div fxFlex="none">
        <strong>{{ problemConnectingText }}</strong>
      </div>
      <button
        mat-raised-button
        flex="none"
        type="button"
        class="main-btn"
        (click)="this.step = 2"
      >
        {{ tryAgainText }}
      </button>
    </div>
  }
</div>
